import { call, put } from 'redux-saga/effects';
import Http from '../../../libs/Http';

export function* fetchMyAccount(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.get, '/users/account', {
    query: {}
  });
  yield put({
    // $global: true,
    type: 'SET_MY_ACCOUNT',
    payload: data,
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* changePassword(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield call(Http.post, '/users/changePassword', {
    body: {
      ...payload.data,
    }
  });
  yield put({
    type: 'FETCH_MY_ACCOUNT',
  });

  yield put({
    type: 'TOGGLE_PASSWORD_CHANGE_MODAL',
    payload: {
      active: false,
    }
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export default function*({ takeFirst, takeLatest }) {
  yield [
    takeLatest('FETCH_MY_ACCOUNT', fetchMyAccount),
    takeLatest('CHANGE_PASSWORD', changePassword),
  ];
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/MyAccount/MyAccount.sagas.js